import { css, styled } from '@mui/material/styles';
import MuiToggleButton from '@mui/material/ToggleButton';

export const ToggleButton = styled(MuiToggleButton)<{ selected?: boolean }>`
  ${({ theme, selected = false }) => css`
    color: ${theme.palette.grey[500]};
    & .Mui-selected,
    &[aria-pressed='true'] {
      background-color: ${theme.palette.primary.light};
      color: ${theme.palette.grey[500]};
    }
    & .Mui-selected:hover,
    &[aria-pressed='true']:hover {
      background: ${selected && theme.palette.primary.light};
    }
  `}
`;
